function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("circle", {
  cx: 26.8676,
  cy: 26.8676,
  r: 26.8676,
  fill: "#A6CE51"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M12.9586 18.3152H16.8466V31.9472H25.2706V35.1152H12.9586V18.3152ZM35.2017 35.4032C33.4897 35.4032 31.9377 35.0352 30.5457 34.2992C29.1697 33.5472 28.0817 32.5152 27.2817 31.2032C26.4977 29.8752 26.1057 28.3792 26.1057 26.7152C26.1057 25.0512 26.4977 23.5632 27.2817 22.2512C28.0817 20.9232 29.1697 19.8912 30.5457 19.1552C31.9377 18.4032 33.4977 18.0272 35.2257 18.0272C36.6817 18.0272 37.9937 18.2832 39.1617 18.7952C40.3457 19.3072 41.3377 20.0432 42.1377 21.0032L39.6417 23.3072C38.5057 21.9952 37.0977 21.3392 35.4177 21.3392C34.3777 21.3392 33.4497 21.5712 32.6337 22.0352C31.8177 22.4832 31.1777 23.1152 30.7137 23.9312C30.2657 24.7472 30.0417 25.6752 30.0417 26.7152C30.0417 27.7552 30.2657 28.6832 30.7137 29.4992C31.1777 30.3152 31.8177 30.9552 32.6337 31.4192C33.4497 31.8672 34.3777 32.0912 35.4177 32.0912C37.0977 32.0912 38.5057 31.4272 39.6417 30.0992L42.1377 32.4032C41.3377 33.3792 40.3457 34.1232 39.1617 34.6352C37.9777 35.1472 36.6577 35.4032 35.2017 35.4032Z",
  fill: "white"
});

function SvgLowCalorie(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 54,
    viewBox: "0 0 54 54",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLowCalorie);
export default __webpack_public_path__ + "static/media/low-calorie.cfa7e3fe.svg";
export { ForwardRef as ReactComponent };